import React, { useEffect } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import { Button, Input } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import ClipLoader from "react-spinners/ClipLoader";
import useEditVehicleModal from "./Hooks/useEditVehicleModal";

const EditVehicleModal = ({ handleEditModalClose, editData, refetch }) => {
  const {
    name,
    model,
    carType,
    color,
    rentalType,
    rentalPrice,
    engineCapacity,
    description,
    imagePreviews,
    isUploading,
    sending,
    setName,
    setModel,
    setCarType,
    setColor,
    setRentalType,
    setRentalPrice,
    setEngineCapacity,
    setDescription,
    handleImagePreview,
    handleSubmit,
  } = useEditVehicleModal({ handleEditModalClose, editData, refetch });

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 text-black">
              {editData ? "Edit Vehicle" : "Add Vehicle"}
            </p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleEditModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100">
            <Row>
              <Col md={6}>
                <Input
                  classes="mt-2 mb-3"
                  type="text"
                  placeholder="Enter name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </Col>
              <Col md={6}>
                <Input
                  classes="mt-2 mb-3"
                  type="text"
                  placeholder="Enter model"
                  value={model}
                  onChange={(e) => setModel(e.target.value)}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Input
                  classes="mt-2 mb-3"
                  type="text"
                  placeholder="Enter car type"
                  value={carType}
                  onChange={(e) => setCarType(e.target.value)}
                />
              </Col>
              <Col md={6}>
                <Input
                  classes="mt-2 mb-3"
                  type="text"
                  placeholder="Enter color"
                  value={color}
                  onChange={(e) => setColor(e.target.value)}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Input
                  classes="mt-2 mb-3"
                  type="number"
                  placeholder="Enter rental price"
                  value={rentalPrice}
                  onChange={(e) => setRentalPrice(e.target.value)}
                />
              </Col>
              <Col md={6}>
                <Input
                  classes="mt-2 mb-3"
                  type="text"
                  placeholder="Enter rental type"
                  value={rentalType}
                  onChange={(e) => setRentalType(e.target.value)}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Input
                  classes="mt-2 mb-3"
                  type="text"
                  placeholder="Enter engine capacity"
                  value={engineCapacity}
                  onChange={(e) => setEngineCapacity(e.target.value)}
                />
              </Col>
              <Col md={6}></Col>
            </Row>

            <Row>
              <Col md={12}>
                <Input
                  classes="mt-2 mb-3"
                  as="textarea"
                  rows={3}
                  placeholder="Enter description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <label className="gray-text">Choose multiple images</label>
                <Input
                  classes="mt-2 mb-3"
                  type="file"
                  placeholder="Image"
                  multiple={true}
                  onChange={handleImagePreview}
                />
              </Col>

              <Col md={12}>
                {isUploading ? (
                  <Spinner />
                ) : (
                  <div className="d-flex flex-wrap gap-2">
                    {imagePreviews.map((preview, index) => (
                      <img
                        key={index}
                        src={preview}
                        alt={`preview ${index}`}
                        width={50}
                        height={50}
                        className="rounded"
                      />
                    ))}
                  </div>
                )}
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <Button
                  classes={`mt-3 mb-2 ${
                    sending ? "bg-dark-subtle" : "shadow"
                  } `}
                  text={
                    sending ? (
                      <ClipLoader color="#000000" size="22px" />
                    ) : editData ? (
                      "Update"
                    ) : (
                      "Save"
                    )
                  }
                  disabled={sending}
                  onClick={handleSubmit}
                ></Button>
              </Col>
            </Row>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default EditVehicleModal;
